// extracted by mini-css-extract-plugin
module.exports = {"customer":"Customer_customer__3Ew0v","input":"Customer_input__3tJzw","TextField":"Customer_TextField__2hcyW","button":"Customer_button__31X7Y"};